import { Gym } from '../../gym';
import { BusinessToolsPermissions } from './business-tools-permissions';
import { Role } from './roles';

type GymResolver = (name: string) => Gym;

export interface IBasicAuthenticationUser {
  name: string;
  roles: Role[];
  gymNames: string[];
  gymDetails: Gym[];
  businessToolsPermissions: BusinessToolsPermissions[];
}

export function getBasicAuthenticationUser(dbUser: any, gymResolver: GymResolver): IBasicAuthenticationUser {
  const gymNames = dbUser.gyms as undefined | string[] || [];
  const gymDetails = gymNames.map(gymResolver);

  return {
    name: dbUser._id,
    roles: dbUser.roles || [],
    gymNames,
    gymDetails,
    businessToolsPermissions: dbUser.businessToolsPermissions || [],
  };
}
